export const routes = {
    profile: '/profile/',
    skills: '/skills/',
    profile2: '/profile2/',
    products: '/products/',
    writings: '/writings/',
};
export const labels = {
    profile: 'Profile',
    profile2: 'Profile2',
    skills: 'Skills',
    products: 'Products',
    writings: 'Writings',
};
export const tabKeys = [
    'profile',
    'skills',
    'profile2',
    'products',
    'writings',
];
export const routeList = tabKeys.map((k) => routes[k]);
export const labelList = tabKeys.map((k) => labels[k]);
